import { SlidingNavigation } from 'models/SlidingNavigation';
import { useNavigation } from '../navigation';
import { Panel } from '../panel';
import { SlidingItem } from './slidingItem';

export const SlidingNavigationBlock = (props: SlidingNavigation) => {
  const { title, items } = props;
  const { openLevel } = useNavigation();
  function open() {
    openLevel(<Panel key={title} header={title} items={items} />);
  }
  return <SlidingItem title={title} onClick={open} />;
};
